import React from 'react';
import * as S from './WeightedShipping.styled';
export const WeightedShipping = () => {
    return (React.createElement(S.Description, null, "We'll do our best to estimate the cost of shipping for a customer's order based on the weight of their order."));
};
